/* 100X Equine reviews: live Loox Storefront API.
   Updates the rating + star distribution and renders real review cards.
   The total count stays on the server-rendered top total (Loox Merchant
   "status=all" via metafield); the Storefront feed is published-only, so it
   is used for rating, distribution, and cards, not the headline count. */
(function () {
  var root = document.querySelector('[data-gx-reviews]');
  if (!root) return;
  var store = root.getAttribute('data-loox-store');
  var pid = root.getAttribute('data-product-id');
  if (!store || !pid) return;
  var base = 'https://storefront-api.loox.io/storefront/v1/store/' + store;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function stars(n) {
    n = Math.max(0, Math.min(5, Math.round(n || 0)));
    var out = '';
    for (var i = 0; i < 5; i++) out += i < n ? '★' : '☆';
    return out;
  }

  /* ----- bottomline: rating + distribution -----

     THE BOTTOMLINE ENDPOINT DOES NOT APPLY LOOX'S PRODUCT GROUPING. Every other surface does.

     Found on Joint Flex Plus 2026-08-06, when Doug asked why the buy box read 4.9. Five ACTIVE
     duplicates share one review pool, and Loox writes the GROUPED figure to each one's metafield
     and serves the grouped feed in its own widget:

        joint-flex-50-savings-halloween-sale   280 reviews   <- what this page's product id is
        joint-flex-1-gallon-bottle-50-off     1178
        joint-flex-one-time-offer               23
        joint-flex-2-gallons-2-day-shipping      6
        joint-flex-case-of-4-barn-pricing        0

     So the metafield said 1,542 at 4.9, Loox's widget said 1,542, and our bars described only
     the 280 on this single id, averaging 4.8179. The page showed a rating from one pool beside a
     count from another. 4.9 is the correct number: weighted across all 1,542 it is 4.904.

     `data-loox-group-ids` lists every product id sharing the pool, and the distributions are
     summed before anything is computed. Only Joint Flex Plus needs it today; the other products'
     bottomline totals land within a few percent of their metafield, which is just the ordinary
     published-only versus status=all gap, not a split pool. Verified 2026-08-06:
     Gut X 15,813 vs 15,906 | Osteo-MAX 8,532 vs 8,824 | Amino 747 vs 750 | Max Calm 422 vs 448.

     WHEN A PRODUCT GETS A NEW DUPLICATE, ADD ITS ID HERE. Symptom of a missed one: the bars
     disagree with the headline count and with Loox's own widget. */
  var groupIds = (root.getAttribute('data-loox-group-ids') || pid)
    .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

  Promise.all(groupIds.map(function (id) {
    return fetch(base + '/product-reviews/bottomline/' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }))
    .then(function (results) {
      var merged = null;
      results.forEach(function (d) {
        if (!d || !d.ratingDistribution) return;
        merged = merged || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        [1, 2, 3, 4, 5].forEach(function (s) {
          merged[s] += Number(d.ratingDistribution[s] || 0);
        });
      });
      // keep the old shape so everything downstream is unchanged
      var d = { ratingDistribution: merged, averageRating: (results[0] || {}).averageRating };
      if (!merged && !d.averageRating) return;
      var dist = d.ratingDistribution;
      var bars = root.querySelector('[data-gx-rv-bars]');

      /* THE RATING IS COMPUTED FROM THE STAR COUNTS, NOT FROM d.averageRating.
         Doug caught this on Amino-MAX 2026-08-06: "how can this be 5 out of 5".

         Loox PRE-ROUNDS averageRating on their side. Amino-MAX's true mean is 4.9505 and their
         field returns exactly 5, so the old `Number(d.averageRating).toFixed(1)` printed "5.0"
         directly above a distribution showing 27 four-star and 5 three-star reviews. A perfect
         score with visible imperfect reviews next to it reads as fabricated, and it is the kind
         of claim that has to be defensible.

         Computing from ratingDistribution instead gives the honest mean AND makes the number
         self-consistent with the bars underneath it, since both now come from the same counts.

         THE 4.9 CAP IS DELIBERATE. 4.9505 rounds to 5.0 by ordinary rules, which is arithmetically
         fine and still a false claim: displayed 5.0 means "nobody rated this under five stars".
         So a 5.0 is only shown when that is literally true. Every other product is unaffected;
         their normal rounding already lands below 5.0. */
      if (dist) {
        var n = 0, weighted = 0;
        [1, 2, 3, 4, 5].forEach(function (s) {
          var c = Number(dist[s] || 0);
          n += c; weighted += s * c;
        });
        if (n > 0) {
          var shown = (weighted / n).toFixed(1);
          if (shown === '5.0' && Number(dist[5] || 0) < n) shown = '4.9';
          root.querySelectorAll('[data-gx-rv-rating]').forEach(function (el) {
            el.textContent = shown;
          });
        }
      } else if (d.averageRating) {
        // no distribution in the payload: fall back, but never let it assert a perfect score
        var fb = Number(d.averageRating).toFixed(1);
        root.querySelectorAll('[data-gx-rv-rating]').forEach(function (el) {
          el.textContent = fb === '5.0' ? '4.9' : fb;
        });
      }

      if (dist && bars) {
        var total = 0;
        [1, 2, 3, 4, 5].forEach(function (s) { total += Number(dist[s] || 0); });
        if (total > 0) {
          var rows = bars.querySelectorAll('.gx-review-bar-row');
          [5, 4, 3, 2, 1].forEach(function (s, i) {
            var count = Number(dist[s] || 0);
            var pct = Math.round((count / total) * 100);
            var row = rows[i];
            if (!row) return;
            // Real low-star counts exist but round under 1% (e.g. 40 three-star of
            // 15,769). Show them as "<1%" with a small sliver rather than 0%, so the
            // true tail reads as honest data, not a fabricated all-five-star spread.
            var few = count > 0 && pct === 0;
            var fill = row.querySelector('.fill');
            if (fill) fill.style.width = (few ? 1.5 : pct) + '%';
            var spans = row.querySelectorAll('span');
            if (spans[1]) spans[1].textContent = few ? '<1%' : pct + '%';
          });
        }
      }
    })
    .catch(function () {});

  /* ----- review CARDS, live from Loox (2026-08-06) -----

     Previously these were curated content from the custom.pdp_reviews metafield, with only the
     aggregate above being live. Doug asked for the real feed on desktop as well as mobile, so
     the cards now come from Loox and the metafield rows become a FALLBACK: if the fetch fails
     the customer still sees reviews rather than an empty grid. Do not delete the server-rendered
     cards from the section.

     `product_id` IS SNAKE CASE AND THIS IS A SILENT TRAP. The bottomline call above takes the
     id as a PATH segment so it is always product-scoped. This one takes a query parameter and
     accepts `product_id` only. `productId`, `productIds`, `product` and `filter[productId]` are
     all ignored WITHOUT ERROR: the API returns 200 and serves the entire store's feed, newest
     first. That put Gut X reviews on the Osteo-MAX page earlier today. Verify any change by
     checking pagination.total against the bottomline count.

     NO TITLES. Loox has no title field, only `body`. The card's <h3 class="ttl"> therefore has
     no source and is omitted rather than filled with the first sentence of the body, which
     would read as a fabricated headline.

     TEXT ONLY, deliberately. The photo-card path (has-photo / rv-photo) was removed from this
     file previously and the design's base three-column grid assumes text. Photos belong to the
     v3 mobile layout, which has a slot for them. */
  var grid = root.querySelector('[data-gx-rv-grid]');
  if (!grid) return;

  fetch(base + '/product-reviews?product_id=' + encodeURIComponent(pid) + '&limit=6')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var revs = (d && d.reviews) || [];
      if (!revs.length) return;
      grid.innerHTML = revs.slice(0, 6).map(function (r) {
        var rv = r.reviewer || {};
        var when = '';
        var dt = new Date(r.date || r.createdAt);
        if (!isNaN(dt)) {
          when = dt.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        }
        return '<div class="gx-review-card"><div class="rv-main">' +
          '<div class="stars">' + stars(r.rating) + '</div>' +
          '<p class="body">' + esc(r.body || '') + '</p>' +
          '<div class="meta">' + esc(rv.name || 'Verified buyer') +
            (r.verified ? '<span class="verified">&#10003; Verified member</span>' : '') +
            (when ? '<div style="margin-top:6px;opacity:0.6">' + esc(when) + '</div>' : '') +
          '</div>' +
        '</div></div>';
      }).join('');
    })
    .catch(function () {});
})();
